import yup from '@/init/yup';
import {
  MOVING_MINUTE_VALUE_TYPES,
  STATION_ADVANCED_SEARCH_TYPES_TYPE,
  STATION_SORT_VALUE_TYPES,
} from '@/types/types';
import { yupResolver } from '@hookform/resolvers/yup';
import { InferType } from 'yup';

export const SearchHospitalsSchema = yup.object({
  searchType: yup.string<STATION_ADVANCED_SEARCH_TYPES_TYPE>(),
  location: yup.object({
    pref_name: yup.string(),
    zipcode: yup.string(),
    address: yup.string(),
    longitude: yup.number(),
    latitude: yup.number(),
    km_radius: yup.number(),
    moving_minutes: yup.string<MOVING_MINUTE_VALUE_TYPES>(),
  }),
  sort: yup.string<STATION_SORT_VALUE_TYPES>(),
  order: yup.string(),
  page: yup.number(),
  filters: yup.array(
    yup.object({ category_id: yup.number(), search_filter_id: yup.number() }),
  ),
  medical_subjects: yup.array(yup.number().required()).required(),
  reported_additional_fees: yup.array(yup.number().required()).required(),
  patient_id: yup.number(),
  partnerName: yup.string(),
});

export type SearchHospitalsType = InferType<typeof SearchHospitalsSchema>;
export const SearchHospitalsResolver = yupResolver(SearchHospitalsSchema);
